import { useState, useEffect } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';
import Index from '@/pages/Index';
import MobileApp from '@/pages/MobileApp';
import { ViewToggle } from '@/components/ViewToggle';

const ResponsiveLayout = () => {
  const isMobile = useIsMobile();
  const [currentView, setCurrentView] = useState<'desktop' | 'mobile'>('desktop');
  const [isDarkMode, setIsDarkMode] = useState(false);

  // Auto-switch to mobile on mobile devices, but allow manual override
  useEffect(() => {
    if (isMobile && currentView === 'desktop') {
      setCurrentView('mobile');
    }
  }, [isMobile, currentView]);

  const handleViewChange = (view: 'desktop' | 'mobile') => {
    // Don't allow desktop view on very small screens
    if (view === 'desktop' && window.innerWidth < 640) {
      return;
    }
    setCurrentView(view);
  };

  const handleThemeToggle = () => {
    setIsDarkMode(!isDarkMode);
    document.documentElement.classList.toggle('dark');
  };

  return (
    <div className="min-h-screen">
      {/* View Toggle Header */}
      <div className="fixed top-4 right-4 z-50">
        <ViewToggle
          currentView={currentView}
          onViewChange={handleViewChange}
          isDarkMode={isDarkMode}
          onThemeToggle={handleThemeToggle}
        />
      </div>

      {/* Main Content */}
      {currentView === 'mobile' ? <MobileApp /> : <Index />}
    </div>
  );
};

export default ResponsiveLayout;